import React, { useState, useCallback } from "react";
import EventSidebar from "./components/EventSidebar";
import EventEditor from "./components/EventEditor";
import { useEvents } from "./hooks/useEvents";
import { eventDefaults } from "../../../models/event";
import { ConfirmDialog, MasterDetailLayout, Breadcrumb } from "../../../components/Common";

/**
 * Events Page (Eventos e Avaliações)
 * Layout Master-Detail: Listagem lateral e editor principal.
 */
const EventsPage = () => {
    const { events, loading, isSaving, actions } = useEvents();
    const [selectedEvent, setSelectedEvent] = useState(eventDefaults);
    const [isDirty, setIsDirty] = useState(false);

    const handleSelectEvent = useCallback(async (event) => {
        if (selectedEvent?.id === event.id) return;

        if (isDirty) {
            const confirmed = await ConfirmDialog({
                title: "Alterações não salvas",
                text: "Você tem alterações pendentes neste evento. Deseja descartá-las?",
                confirmButtonText: "Sim, descartar",
                cancelButtonText: "Cancelar"
            });
            if (!confirmed) return;
        }

        setSelectedEvent(event);
        setIsDirty(false);
    }, [selectedEvent, isDirty]);

    const handleCreateNew = useCallback(async () => {
        if (isDirty) {
            const confirmed = await ConfirmDialog({
                title: "Alterações não salvas",
                text: "Deseja descartar as mudanças atuais e criar um novo evento?",
                confirmButtonText: "Sim, descartar",
                cancelButtonText: "Cancelar"
            });
            if (!confirmed) return;
        }
        setSelectedEvent(eventDefaults);
        setIsDirty(false);
    }, [isDirty]);

    const handleSave = useCallback(async (data) => {
        const success = await actions.saveEvent(data);
        if (success) {
            setIsDirty(false);
            if (!data.id) {
                setSelectedEvent(eventDefaults);
            }
        }
    }, [actions]);

    const handleDirtyChange = useCallback((dirty) => setIsDirty(dirty), []);

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Avaliações e Eventos" />
            </div>

            <div className="border-top mb-3"></div>

            <div className="events-container mt-3">
                <MasterDetailLayout
                master={
                    <EventSidebar
                        events={events || []}
                        activeId={selectedEvent?.id}
                        onSelect={handleSelectEvent}
                        onCreateNew={handleCreateNew}
                        loading={loading}
                    />
                }
                detail={
                    <EventEditor
                        event={selectedEvent}
                        onSave={handleSave}
                        isSaving={isSaving}
                        onChange={handleDirtyChange}
                    />
                }
            />
            </div>
        </React.Fragment>
    );
};

export default EventsPage;
